import { useSelector } from "react-redux";
import PageHeaders from "../../components/pageHeaders";
import MessageStats from "./components/messageStats";

const WhatsAppMessageStats = () => {
  const user = useSelector((state: any) => state?.User?.user);
  const office = user?.office;
  
  const sessionId = office?.whatsapp_server_url;

  return (
    <div>
      <PageHeaders 
        title="WhatsApp Message Statistics" 
        breadcrumb="WhatsApp / Message Statistics" 
      />
      <div className="screenBox">
        <MessageStats sessionId={sessionId} />
      </div>
    </div>
  );
};

export default WhatsAppMessageStats;